import React from "react";
import { useNavigate } from "react-router-dom";
import { useClipsStore } from "./ClipsStore/clipsStore";
import { updateClipsSearchParams } from "./ClipsUtilities/clipsUrlParams";

export const ApplyFiltersButtonFrontel = (props?: {
  setSearchParams?: (params: URLSearchParams) => void;
}) => {
  const { setSearchParams } = props ?? {};
  const navigate = useNavigate();

  const {
    setFrontelData,
    setPageFrontel,
    setSelectedRowFrontel,
    setPrecisionRecallDataFrontel,
    setNoDataToDisplayFrontel,
    setFetchingFilteredDataFrontel,
    setFiltersAppliedFrontel,
    setLoadingAdditionalDataFrontel,
    getFrontelData,
    userFiltersFrontel,
  } = useClipsStore();

  return (
    <button
      className="shadow-button bg-actuate-orange border-2	border-actuate-orange rounded font-mulish text-white text-base p-1.5 w-[120px] hover:bg-[#E67300]"
      onClick={() => {
        setFiltersAppliedFrontel(true);
        setLoadingAdditionalDataFrontel(true);
        setFrontelData([]);
        setPageFrontel(0);
        setNoDataToDisplayFrontel(true);
        setSelectedRowFrontel({});
        setPrecisionRecallDataFrontel([]);
        setFetchingFilteredDataFrontel(true);
        getFrontelData(navigate);
        if (setSearchParams) {
          updateClipsSearchParams(
            setSearchParams,
            "frontel",
            userFiltersFrontel
          );
        }
      }}
      disabled={false}
    >
      Apply Filters
    </button>
  );
};
